var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"main"},[_c('MatsListing',{attrs:{"rows-length-data":_vm.materialLength},on:{"sendMaterial":_vm.materialId}}),_c('InventoryMaterialVariant',{attrs:{"material-id":_vm.materialIdToShow,"measure-id":_vm.materialMeasure,"material-name":_vm.materialName},on:{"rowsLength":_vm.rowsLengthItem}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }